import type { Subject, TaskSummary } from "../api.js";
import { AccountMenu } from "../components/AccountMenu.js";
import { BottomNav } from "../components/BottomNav.js";
import { TaskCard } from "../components/TaskCard.js";
import { taskMatchesFilter, type TaskFilter } from "../task-presentation.js";

const filterLabels: Record<TaskFilter, string> = {
  all: "全部任务",
  waiting: "等待确认",
  active: "进行中",
  done: "已完成",
  attention: "需处理",
  closed: "已取消",
};

function currentFilter(): TaskFilter {
  const value = new URLSearchParams(window.location.search).get("filter");
  return value === "waiting" ||
    value === "active" ||
    value === "done" ||
    value === "attention" ||
    value === "closed"
    ? value
    : "all";
}

export function TasksPage({
  subject,
  tasks,
  onLogout = async () => undefined,
}: {
  subject: Subject;
  tasks: TaskSummary[];
  onLogout?: () => Promise<void>;
}) {
  const filter = currentFilter();
  const visible = tasks.filter((task) => taskMatchesFilter(task.status, filter));
  return (
    <div className="app-shell">
      <header className="mobile-header">
        <div>
          <p className="eyebrow">TASK CENTER</p>
          <h1>{filterLabels[filter]}</h1>
        </div>
        <AccountMenu subject={subject} onLogout={onLogout} />
      </header>
      <main className="page-content">
        <nav className="task-filter-row" aria-label="任务筛选">
          {(["all", "waiting", "active", "done", "attention", "closed"] as TaskFilter[]).map((value) => (
            <a
              href={value === "all" ? "/tasks" : "/tasks?filter=" + value}
              className={filter === value ? "active" : ""}
              key={value}
            >
              {value === "all" ? "全部" : filterLabels[value]}
            </a>
          ))}
        </nav>
        <div className="task-list">
          {visible.map((task) => (
            <TaskCard task={task} key={task.taskId} />
          ))}
          {visible.length === 0 ? (
            <div className="empty-card">当前筛选下没有任务。</div>
          ) : null}
        </div>
      </main>
      <BottomNav active="tasks" />
    </div>
  );
}
